export default __webpack_public_path__ + "static/media/twitter.2b9bf0c7.svg";